import React from 'react'
import { Friend } from '../types/friend'
import { FollowStatus } from '../constants/follow'
import SmallBadgeButton from './SmallBadgeButton'
import Avatar from './Avatar'

export interface ContactFriendListItemProps {
  friend: Friend
  onFollowClick: (friend: Friend) => void
  onSendAppLinkClick: (friend: Friend) => void
}

const ContactFriendListItem: React.FC<ContactFriendListItemProps> = ({
  friend,
  onFollowClick,
  onSendAppLinkClick,
}) => {
  return (
    <div className="flex items-center gap-12px w-full px-12px py-12px">
      <Avatar
        nickname={friend.name}
        profileImage={friend.profileImage}
        size={48}
      />

      <div className="flex-1 min-w-0">
        <span className="text-style-captionL text-textColorText2 text-ellipsis-1 block">
          {friend.name}
        </span>
      </div>

      {friend.userId ? (
        <SmallBadgeButton
          label={
            friend.followStatus === FollowStatus.NONE
              ? '팔로우'
              : friend.followStatus === FollowStatus.REQUESTED
                ? '요청중'
                : '팔로잉'
          }
          variant={
            friend.followStatus === FollowStatus.NONE ? 'default' : 'inverse'
          }
          onClick={() => onFollowClick(friend)}
        />
      ) : (
        <SmallBadgeButton
          label="메시지"
          onClick={() => onSendAppLinkClick(friend)}
        />
      )}
    </div>
  )
}

export default ContactFriendListItem
